<template>
    <vs-table v-if="show" :params="params" :options="options" @onCreateHeaderActionClicked="openUserAccess('create')"></vs-table>
</template>

<script>
import VsTable from "../_framework/VsTable.vue";

export default {
  name: "access",
  created: () => {},
  beforeMount() {
    this.options.access = checkAccess(this.$route.path);
    //console.log(this.options.access);
    this.show = !!this.options.access;
  },
  components: {
    VsTable
  },
  data() {
    return {
      show: true,
      access: {},
      params: {
        entity: "access",
        list: [],
        headers: {
          name: {
            title: "عنوان دسترسی",
            type: "text"
          }
        }
      },
      options: {
        hasActions: true,
        hasActionsInHeader: true,
        clickableRows: true,
        onCreateHeaderActionClicked: true,
        onEditClicked: (row, context) => {
          this.openUserAccess("edit", row.id);
        },
        onRowDoubleClicked: row => {
          this.openUserAccess("view", row.id);
        },
        getTopRightButtons: () => {
          let arr = [];
          let searchToggleButton = {
            component: "search-toggle-button"
          };
          arr.push(searchToggleButton);
          return arr;
        },
        getTopLeftButtons: () => {
          let arr = [];
          let self = this;
          let addItemButton = {
            component: "toggle-table-actions-button",
            params: {
              onClick() {
                self.options.hasActions = !self.options.hasActions;
              }
            }
          };
          arr.push(addItemButton);
          return arr;
        }
      }
    };
  },
  methods: {
    openUserAccess(mode, id) {
      this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
      this.$router.push({
        path: "/user-accesses",
        query: { id, mode }
      });
    }
  }
};
</script>
